import { FC } from "react";

type Props = {
  numberOfResults: number;
};

const PlaceholderSearchResults: FC<Props> = ({ numberOfResults }) => {
  const placeholderResults = new Array(numberOfResults)
    .fill(0)
    .map((_, index) => <PlaceholderSearchResult key={index} />);

  return (
    <div className="PlaceholderSearchResults w-full h-full pt-2 mb-6 grid gap-5 grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {placeholderResults}
    </div>
  );
};

export function PlaceholderSearchResult() {
  return (
    <div className="CardMemberProfile xs:max-w-[250px] max-w-[170px] bg-center m-auto md:h-[330px] h-[224px] rounded-2xl overflow-hidden bg-cover relative col-span-1 w-full wave-load">
      <div className="flex flex-col justify-end cursor-pointer items-end md:py-3.5 py-2.5 md:px-3.5 px-2.5 h-full w-full bg-gradient"></div>
    </div>
  );
}

export default PlaceholderSearchResults;
